/* Home sections that load as the visitor scrolls (snippets/lazy-section.liquid).
   Rule (Aditya, 2026-10-15): when section n is on screen, section n+2 loads.
   n and n+1 are loaded too, for a visitor who lands mid-page (a restored
   scroll position) or flings past a section.

   A deferred section arrives as an empty box; this swaps in the real one
   from Shopify's Section Rendering API, keeps the section's own wrapper
   (so section-scoped scripts find it with closest('.shopify-section')), and
   re-runs its scripts, which innerHTML-style insertion would leave inert.
   Product cards, currency conversion and the wishlist already watch the page
   for new content, so they pick the new cards up on their own. */
(function () {
  'use strict';
  if (window.__tzLazySections) return;
  window.__tzLazySections = true;

  var main = document.getElementById('MainContent');
  if (!main || !('IntersectionObserver' in window) || !window.fetch) return;

  var pending = new Map();

  function sections() {
    return Array.prototype.filter.call(main.children, function (el) {
      return el.classList.contains('shopify-section');
    });
  }

  // Scripts parsed out of fetched HTML never run; put fresh copies in their
  // place, in order. A script file already on the page is not loaded twice.
  function revive(root) {
    root.querySelectorAll('script').forEach(function (old) {
      var type = (old.getAttribute('type') || '').toLowerCase();
      if (type && type !== 'text/javascript' && type !== 'module' && type !== 'application/javascript') return;
      if (old.src) {
        var src = old.getAttribute('src');
        var already = Array.prototype.some.call(document.scripts, function (s) {
          return s !== old && s.getAttribute('src') === src && !root.contains(s);
        });
        if (already) { old.remove(); return; }
      }
      var fresh = document.createElement('script');
      Array.prototype.forEach.call(old.attributes, function (a) { fresh.setAttribute(a.name, a.value); });
      if (!old.src) fresh.textContent = old.textContent;
      old.replaceWith(fresh);
    });
  }

  function inject(section, box, html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fetched = doc.getElementById(section.id) || doc.body.firstElementChild;
    if (!fetched || !box.isConnected) return;
    // The fetched wrapper may carry classes the placeholder render did not.
    Array.prototype.forEach.call(fetched.classList, function (c) { section.classList.add(c); });
    var frag = document.createDocumentFragment();
    Array.prototype.forEach.call(fetched.childNodes, function (node) {
      frag.appendChild(document.importNode(node, true));
    });
    box.replaceWith(frag);
    revive(section);
    section.dispatchEvent(new CustomEvent('tz:section-loaded', { bubbles: true }));
  }

  function load(section) {
    if (!section || pending.has(section)) return;
    var box = section.querySelector('[data-tz-lazy-section]');
    if (!box) return;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var url = root + '?section_id=' + encodeURIComponent(box.getAttribute('data-tz-lazy-section'));
    pending.set(section, fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('section ' + r.status);
        return r.text();
      })
      .then(function (html) { inject(section, box, html); })
      .catch(function () {
        // Let the next time it comes into view try again.
        pending.delete(section);
      }));
  }

  var observer = new IntersectionObserver(function (entries) {
    var list = sections();
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var i = list.indexOf(e.target);
      if (i < 0) return;
      load(list[i]);
      load(list[i + 1]);
      load(list[i + 2]);
    });
  });
  sections().forEach(function (s) { observer.observe(s); });
})();
